import { render, staticRenderFns } from "./container.vue?vue&type=template&id=07358e06&scoped=true&"
import script from "./container.vue?vue&type=script&lang=ts&"
export * from "./container.vue?vue&type=script&lang=ts&"
import style0 from "./container.vue?vue&type=style&index=0&id=07358e06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07358e06",
  null
  
)

export default component.exports